import en from "./en";
import zh from "./zh";
import es from "./es";
import pt from "./pt";
import fr from "./fr";
import ja from "./ja";
import ko from "./ko";
import ar from "./ar";
import de from "./de";
import ru from "./ru";
import STOREFRONT_TEXTS from "../pages/storefront/storefrontI18n";

const LANGUAGES = {
  en,
  zh,
  es,
  pt,
  fr,
  ja,
  ko,
  ar,
  de,
  ru
};
const STORE_LANGUAGE_LABELS = {
  en: "English",
  zh: "简体中文",
  es: "Español",
  pt: "Português",
  fr: "Français",
  ja: "日本語",
  ko: "한국어",
  ar: "العربية (السعودية)",
  de: "Deutsch",
  ru: "Русский"
};

const STORE_LANGUAGE_FLAGS = {
  en: "🇺🇸",
  zh: "🇨🇳",
  es: "🇪🇸",
  pt: "🇵🇹",
  fr: "🇫🇷",
  ja: "🇯🇵",
  ko: "🇰🇷",
  ar: "🇸🇦",
  de: "🇩🇪",
  ru: "🇷🇺"
};

export const STOREFRONT_SUPPORTED_LOCALES = new Set(Object.keys(LANGUAGES));

export const STOREFRONT_LANGUAGE_OPTIONS = Object.keys(LANGUAGES).map((value) => ({
  value,
  label: STORE_LANGUAGE_LABELS[value] || value,
  flag: STORE_LANGUAGE_FLAGS[value] || "🌐"
}));

let currentLang = "en";

function getByPath(source, keyPath) {
  if (!source || typeof source !== "object") {
    return undefined;
  }

  const keys = String(keyPath || "").split(".").filter(Boolean);
  if (!keys.length) {
    return undefined;
  }

  let cursor = source;
  for (const key of keys) {
    if (!cursor || typeof cursor !== "object" || !(key in cursor)) {
      return undefined;
    }
    cursor = cursor[key];
  }

  return cursor;
}

export function setLang(lang) {
  if (LANGUAGES[lang]) currentLang = lang;
}

export function getLang() {
  return currentLang;
}

export function t(key) {
  const activeLanguage = LANGUAGES[currentLang] || LANGUAGES.en;
  const defaultLanguage = LANGUAGES.en;
  const storefrontLanguage = STOREFRONT_TEXTS[currentLang] || STOREFRONT_TEXTS.en || STOREFRONT_TEXTS.zh;
  const storefrontDefaultLanguage = STOREFRONT_TEXTS.en || STOREFRONT_TEXTS.zh;

  const activeResolved = getByPath(activeLanguage, key);
  if (typeof activeResolved === "string") {
    return activeResolved;
  }

  const storefrontResolved = getByPath(storefrontLanguage, key);
  if (typeof storefrontResolved === "string") {
    return storefrontResolved;
  }

  const defaultResolved = getByPath(defaultLanguage, key);
  if (typeof defaultResolved === "string") {
    return defaultResolved;
  }

  const storefrontDefaultResolved = getByPath(storefrontDefaultLanguage, key);
  if (typeof storefrontDefaultResolved === "string") {
    return storefrontDefaultResolved;
  }

  return key;
}

export default { t, setLang };
